// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { link16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-link': IconLink;
    }
}

/**
 * The icon component for the 'link' icon
 */
export class IconLink extends IconSvg {
    public constructor() {
        super(link16X16);
    }
}

registerIconSvg('icon-link', IconLink);
export const iconLinkTag = 'nimble-icon-link';
